/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sec_Pg_L2Inputs */

const en_mk_sec_pg_l2 = /** @type {(inputs: Mk_Sec_Pg_L2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign-in with Google or an email code`)
};

const id_mk_sec_pg_l2 = /** @type {(inputs: Mk_Sec_Pg_L2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masuk dengan Google atau kode email`)
};

/**
* | output |
* | --- |
* | "Sign-in with Google or an email code" |
*
* @param {Mk_Sec_Pg_L2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sec_pg_l2 = /** @type {((inputs?: Mk_Sec_Pg_L2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sec_Pg_L2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sec_pg_l2(inputs)
	return en_mk_sec_pg_l2(inputs)
});